"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyButton = void 0;
const pick_1 = __importDefault(require("lodash/pick"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const StyledButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    'data-id': `travelDatesApplyButton`,
    className: 'applyButton',
})({
    width: '100%',
    borderRadius: '0px',
});
const ApplyButton = ({ state, saveTravelDates, children, initialReturnDate, postSaveAction, }) => {
    const { departureDate, duration, returnDate, searchType, extraDurations, } = state;
    const { t, i18n } = (0, next_i18next_1.useTranslation)(['forms']);
    const ariaLabel = i18n.exists('forms:applyButton.datesAria')
        ? t('forms:applyButton.datesAria')
        : null;
    return (react_1.default.createElement(StyledButton, { disabled: !returnDate, onClick: () => {
            saveTravelDates({
                departureDate: departureDate,
                returnDate: returnDate || initialReturnDate,
                searchType,
                duration: (0, pick_1.default)(duration, 'duration', 'type'),
                extraDurations,
            });
            if (postSaveAction && typeof postSaveAction === 'function')
                postSaveAction();
        }, "aria-label": ariaLabel }, children));
};
exports.ApplyButton = ApplyButton;
//# sourceMappingURL=ApplyButton.js.map